import React, { createContext, useMemo } from 'react';
import FirebaseService from "../services/FirebaseService";
import UserService from "../services/UserService";
import { useNavigate } from 'react-router-dom';
import RacesService from '../services/RacesService';
import PlansService from '../services/PlansService';
import MapService from '../services/MapService';
import NutritionProductsService from '../services/NutritionProductsService';
import OrdersService from '../services/OrdersService';
import FeatureRequestService from '../services/FeatureRequestService';
import StravaService from '../services/StravaService';
import ComparisonsService from '../services/ComparisonsService';
import AnalysisService from '../services/AnalysisService';
import TrainingRunsService from '../services/TrainingRunsService';
import SurveyService from '../services/SurveyService';
import ReviewService from '../services/ReviewService';

export interface AppContextType {
    firebaseService: FirebaseService;
    userService: UserService;
    racesService: RacesService;
    plansService: PlansService;
    nutritionProductsService: NutritionProductsService;
    ordersService: OrdersService;
    mapService: MapService;
    featureRequestService: FeatureRequestService,
    stravaService: StravaService,
    comparisonsService: ComparisonsService,
    analysisService: AnalysisService,
    trainingRunsService: TrainingRunsService,
    surveyService: SurveyService,
    reviewService: ReviewService,
}

interface AppProviderProps {
    children: React.ReactNode;
}

export const AppContext = createContext<AppContextType>(
    {} as AppContextType
);

export const AppProvider: React.FC<AppProviderProps> = ({ children }) => {

    const navigate = useNavigate();



    const value = useMemo(() => {
        const firebaseService = new FirebaseService();
        const ordersService = new OrdersService(firebaseService);

        const userService = new UserService(firebaseService, navigate, ordersService);
        userService.init();

        return {
            firebaseService,
            userService: userService,
            racesService: new RacesService(firebaseService),
            plansService: new PlansService(firebaseService),
            mapService: new MapService(),
            ordersService: ordersService,
            nutritionProductsService: new NutritionProductsService(firebaseService),
            featureRequestService: new FeatureRequestService(firebaseService),
            stravaService: new StravaService(userService),
            comparisonsService: new ComparisonsService(firebaseService),
            analysisService: new AnalysisService(firebaseService),
            trainingRunsService: new TrainingRunsService(firebaseService),
            surveyService: new SurveyService(firebaseService),
            reviewService: new ReviewService(firebaseService),
        }

    }, [navigate]);

    return (
        <AppContext.Provider value={value}>
            {children}
        </AppContext.Provider>
    );
};
